import React from 'react';
import { motion } from 'framer-motion';
import { CookieModalHeader, CookieModalFooter, CookieModalBody } from './CookieModalParts';

const FADE_OUT = { opacity: 0, transition: { duration: 0.2 } };
const FADE_IN = { opacity: 1 };
const MODAL_HIDDEN = { opacity: 0, y: 50, scale: 0.95 };
const MODAL_EXIT = { ...MODAL_HIDDEN, transition: { duration: 0.2 } };
const MODAL_VISIBLE = { opacity: 1, y: 0, scale: 1 };
const MODAL_TRANSITION = { type: 'spring', damping: 25 };

const CookieModal = ({ isOpen, onClose, onAcceptAll, onRejectAll, onSavePreferences, t, ...bodyProps }) => {
  if (!isOpen) return null;
  const cookies = t?.cookies;

  return (
    <>
      <motion.div
        initial={FADE_OUT}
        animate={FADE_IN}
        exit={FADE_OUT}
        onClick={onClose}
        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50"
      />
      <motion.div
        initial={MODAL_HIDDEN}
        animate={MODAL_VISIBLE}
        exit={MODAL_EXIT}
        transition={MODAL_TRANSITION}
        className="fixed inset-0 z-50 flex items-center justify-center p-4"
      >
        <div data-testid="cookie-modal" className="relative w-full max-w-3xl max-h-[90vh] overflow-y-auto bg-white rounded-2xl shadow-2xl">
          <CookieModalHeader cookies={cookies} onClose={onClose} />
          <CookieModalBody cookies={cookies} {...bodyProps} />
          <CookieModalFooter
            cookies={cookies}
            onRejectAll={onRejectAll}
            onSavePreferences={onSavePreferences}
            onAcceptAll={onAcceptAll}
          />
        </div>
      </motion.div>
    </>
  );
};

export default CookieModal;
